import React, { useState } from 'react';
import TestimonialsHeader from '../components/Testimonials/TestimonialsHeader';
import VideoGrid from '../components/Testimonials/VideoGrid'; 
import VideoModal from '../components/VideoModal'; 
import { testimonialsData } from '../utils/testimonialsData';
import Testimonials from '../components/Home/Testimonials';


const TestimonialsPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoLink, setCurrentVideoLink] = useState('');

  const handleVideoClick = (link) => {
    setCurrentVideoLink(link);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentVideoLink(''); 
  };

  const handleWatchFullVideoInHeader = (link) => {
    setCurrentVideoLink(link);
    setIsModalOpen(true);
  };


  return (
    <div className="testimonials-page"> 
      <TestimonialsHeader onWatchFullVideoClick={handleWatchFullVideoInHeader} />
      <div className="testimonials-content">
        <VideoGrid videos={testimonialsData} onVideoClick={handleVideoClick} />
      </div>

      <VideoModal
        isOpen={isModalOpen}
        videoLink={currentVideoLink}
        onClose={handleCloseModal}
      />
      <Testimonials/>
    </div>
  );
};

export default TestimonialsPage;